// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo--6PZUP","contentWrapp":"contentWrapp--gnIHt"};